import { createTheme, makeStyles } from '@material-ui/core';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';
import { calculateHeight, calculateWidth } from 'src/common/helpers/dimension-helper';
import loginImage from 'src/login/media/Login-background-img.png';
import { themeColor } from 'src/mui-theme';

declare module '@material-ui/core/styles/overrides' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface ComponentNameToClassKey extends MuiPickersOverrides {}
}

export const newStyles = makeStyles(theme => ({
  welcomeTextSpacing: {
    position: 'relative',
    top: '17vh',
  },
  bluebutton: {
    fontWeight: 500,
    boxShadow: 'none',
    borderRadius: 2,
    letterSpacing: 1.61,
    height: '7.29vh',
    width: '18.49vw',
    color: themeColor.white,
    marginLeft: '1.171vw',
  },
  loginContainer: {
    height: '51.563vh',
    alignContent: 'center',
    paddingBottom: '1.172vh',
  },
  loginContainerTraining: {
    height: '51.563vh',
    position: 'relative',
    '@media (width: 1024px) and (height: 576px)': {
      bottom: '2vh',
    },
    paddingBottom: '1.172vh',
  },
  registerContainer: {
    height: '61.458vh',
    position: 'relative',
    bottom: '12vh',
    '@media (width: 1024px) and (height: 576px)': {
      bottom: '17vh',
    },
  },
  cancelbutton: {
    backgroundColor: themeColor.white,
    fontWeight: 500,
    boxShadow: 'none',
    borderRadius: 2,
    letterSpacing: 1.61,
    minHeight: '6.25vh',
    border: `solid 1px ${themeColor.secondaryLight}`,
    width: '18.49vw',
    height: '7.29vh',
  },
  submitContainer: {
    textAlign: 'right',
  },
  buttonContainer: {
    paddingTop: '20px',
  },
  trainingButtonContainer: {
    paddingTop: '8px',
  },
  buttondefaultfont: {
    fontSize: '2.34vh',
    lineHeight: '0.11vh',
    letterSpacing: '0.11vw',
    color: themeColor.almostblack,
    '@media (aspect-ratio: 4/3)': {
      fontSize: '1.99vh',
    },
  },
  iamButton: {
    marginLeft: '0',
  },
  buttonwhitefont: {
    fontSize: '2.34vh',
    lineHeight: '0.11vh',
    letterSpacing: '0.11vw',
    color: themeColor.white,
    '@media (aspect-ratio: 4/3)': {
      fontSize: '1.99vh',
    },
    '&.Mui-disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: 1,
    },
  },
  whiteiconbutton: {
    color: themeColor.palesky,
  },
  margintopsignagediv: {
    marginTop: '20%',
  },
  typographytitle: {
    color: themeColor.defaultDarkTextColor,
    letterSpacing: 0.25,
    fontSize: '3.9vh',
  },
  typographytitlecontainer: {
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
    width: '6vh',
  },
  icon: {
    height: '3.12vh',
    width: '1.39vw',
    color: themeColor.blackpearl,
  },
  registerform: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 0,
    paddingTop: '0.781vh',
    height: '53.5vh',
  },
  loginform: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 0,
    paddingTop: '0.781vh',
    height: '41.67vh',
  },
  menuicon: {
    fontSize: '2.85vw',
    backgroundColor: 'transparent',
    color: 'white',
    width: '3.45vh',
    height: '2.03vh',
  },
  menucontainer: {
    marginLeft: '0.4vw',
    marginTop: '1.5vh',
  },
  brandlogostyle: {
    marginBottom: calculateHeight(15, 768).stringValue,
    height: '9.115vh',
    paddingRight: '0.89vw',
  },
  productnametypography: {
    height: '7.29vh',
    paddingLeft: '2.41vw',
    fontFamily: 'Raleway, sans-serif',
    fontSize: '6.25vh',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColor.white,
    fontVariant: 'lining-nums',
  },
  productcontainerbase: {
    width: '25.44vw',
    padding: '0 10px 0 0',
  },
  normalproductcontainer: {
    borderLeft: `10px solid ${theme.palette.secondary.main}`,
  },
  normalProductLogoContainer: {
    alignItems: 'center',
    flexDirection: 'column',
  },
  trainingproductcontainer: {
    borderLeft: `10px solid ${themeColor.trainingColor}`,
  },
  versiontypography: {
    color: themeColor.lockTextColor,
    marginBottom: calculateHeight(15, 768).stringValue,
    paddingLeft: '16px',
    textAlign: 'left',
    fontFamily: 'Raleway, sans-serif',
    fontSize: '0.875rem',
    fontWeight: 'bold',
  },
  signagebackground: {
    backgroundImage: `url(${loginImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    flexBasis: calculateWidth(604, 1366).stringValue,
  },
  signagebottomcontainer: {
    position: 'fixed',
    marginBottom: 10,
    bottom: 0,
  },
  loginField: {
    '& .MuiOutlinedInput-root': {
      width: '100%',
      '& fieldset': {
        borderRadius: '2px',
      },
    },
    height: '11.9vh',
  },
  loginDeviceIcon: {
    paddingLeft: '1.5vh',
  },
  registerFieldRegistration: {
    width: '100%',
    paddingBottom: '2vh',
  },
  registerFieldUnderline: {
    '& label': {
      color: themeColor.tangaroa,
      '@media (min-height: 1080px)': {
        fontSize: '1.3rem',
      },
    },
    '& > div.MuiInput-underline': {
      '&:before': {
        borderBottom: `0.398406374501992vh solid ${themeColor.borderGray}`,
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `0.11614401858304298vh solid ${themeColor.borderGray}`,
      },
      '&:after': {
        borderBottom: `0.398406374501992vh solid ${theme.palette.secondary.main}`,
      },
    },
  },
  loginFieldTraining: {
    '& .MuiOutlinedInput-root': {
      width: '100%',
      height: '61%',
      '& fieldset': {
        borderRadius: '0.376% / 3.98%',
      },
    },
    height: '9.64vh',
  },
  dateField: {
    '& .MuiOutlinedInput-root': {
      width: '80%',
      '& fieldset': {
        borderRadius: '2px',
      },
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: theme.palette.secondary.main,
    },
    height: '11.9vh',
  },
  timeField: {
    paddingLeft: '10%',
  },
  topIconPanel: {
    height: '9.9vh',
    margin: '0px',
  },
  topIconPanelTraining: {
    height: '9.51vh',
  },
  topContainer: {
    paddingTop: '3.385vh',
    paddingLeft: '1.684vw',
  },
  errorMessage: {
    fontSize: '2.08vh',
    width: '35.18vw',
    color: theme.palette.info.dark,
    fontWeight: 500,
    letterSpacing: '0.1vw',
    fontStretch: 'normal',
    fontStyle: 'normal',
    '@media (aspect-ratio: 4/3)': {
      fontSize: '1.6vh',
    },
  },
  erroricon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
    '@media (aspect-ratio: 4/3)': {
      height: '2.3vh',
    },
  },
  formError: {
    height: '4.6vh',
    paddingTop: '2vh',
    paddingBottom: '5vh',
  },
  formErrorTraining: {
    height: '5.21vh',
    paddingTop: '2vh',
  },
  iamButtonContainer: {
    marginTop: '5vh',
  },
}));

export const datetimeTheme = createTheme({
  palette: {
    primary: {
      main: themeColor.secondaryMain,
    },
  },
  typography: {
    h2: {
      fontSize: '1.75rem',
    },
  },
  overrides: {
    MuiIconButton: {
      root: {
        borderRadius: '0px',
      },
    },
    MuiPickersDay: {
      daySelected: {
        border: `3px solid ${themeColor.secondaryMain}`,
        backgroundColor: themeColor.white,
      },
      day: {
        border: `1px solid ${themeColor.secondaryLight}`,
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        justifyContent: 'space-evenly',
        backgroundColor: themeColor.modalBackground,
      },
    },
    MuiPickersTimePickerToolbar: {
      ampmSelection: {
        flexDirection: 'row',
        marginLeft: 0,
        width: '40%',
        justifyContent: 'space-around',
        '& > button': {
          backgroundColor: themeColor.white,
        },
      },
      ampmLabel: {
        backgroundColor: themeColor.white,
        padding: '0.315rem 0.63rem',
      },
      toolbarAmpmLeftPadding: {
        paddingLeft: 0,
      },
    },
    MuiPickersClock: {
      clock: {
        backgroundColor: themeColor.modalBackground,
      },
    },
    MuiPickersClockPointer: {
      thumb: {
        borderColor: themeColor.white,
        boxShadow: `0 0 0 2pt ${themeColor.secondaryMain}`,
      },
    },
    // @ts-ignore
    MuiPickersToolbarText: {
      toolbarBtnSelected: {
        // for the am/pm.. they are h6
        '&:not(h2)': {
          border: `2px solid ${themeColor.secondaryMain}`,
          borderRadius: '2px',
        },
        //for the time... they are h2
        '&:not(h6)': {
          fontWeight: 'bold',
          color: themeColor.secondaryMain,
        },
      },
    },
  },
});
